/*
  SLB Native GDG Contribution Page
  Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
*/
(function(w,d){
  'use strict';

  var TAB='gdgToken';
  var HERO='https://cdn.shopify.com/s/files/1/1299/3411/files/ChatGPT_Image_Jul_21_2026_06_05_40_PM.png?v=1784671584';
  var PAYPAL='https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=CEZ8SJ384KWKE';

  function el(id){return d.getElementById(id)}

  function pageHtml(){
    return ''+
      '<div class="slbGdgPage">'+
        '<div class="slbGdgHero">'+
          '<img src="'+HERO+'" alt="GDG Contribution" loading="eager" decoding="async">'+
        '</div>'+

        '<section class="slbGdgPrimaryCta" aria-label="Make a GDG contribution">'+
          '<a class="slbGdgPayButton" href="'+PAYPAL+'" target="_blank" rel="noopener noreferrer" role="button">'+
            '<span>Do Contribution</span>'+
            '<small>Continue with PayPal</small>'+
          '</a>'+
        '</section>'+

        '<main class="slbGdgReading">'+
          '<section class="slbGdgTextBlock">'+
            '<h1>What GDG Does</h1>'+
            '<p>GDG contribution goes to Beh Si Juen in Hong Kong. She gathers everyone’s contribution into one shared pool, then uses it to support the HQ side, where Jee Si Juen and Gum Si Juen are.</p>'+
            '<p>Sometimes this support becomes food uploads. Sometimes it is used for other needs that protect their well-being, keep HQ running, and help the lineage continue to grow in a positive way.</p>'+
          '</section>'+

          '<section class="slbGdgTextBlock slbGdgTextBlockSoft">'+
            '<h2>Building Blood-and-Chi Linkage</h2>'+
            '<p>When you contribute, your blood and chi enter the same pool together with Beh Si Juen’s blood and chi. Whenever she makes an upload to HQ, your blood and chi also travel with it and mix with Jee Si Juen and Gum Si Juen at HQ.</p>'+
            '<p>Because the YS of the Si Juen receives your blood and chi, your linkage and affinity with them become stronger. Their YS will have a stronger bond with you and will naturally want to support and help you more. With their support behind you, your magic power can also become stronger and more effective.</p>'+
          '</section>'+

          '<section class="slbGdgTextBlock">'+
            '<h2>Merit and the Longevity of Your Tao Life</h2>'+
            '<p>Your contribution is an investment into the Tao. It builds merit and strengthens your affinity with the Tao. Over time, this supports the positive growth and longevity of your Tao life.</p>'+
            '<p>This is the main purpose of GDG: supporting HQ while building a stronger living connection between you, the Si Juen, the lineage, and the Tao.</p>'+
          '</section>'+
        '</main>'+
      '</div>';
  }

  function init(){
    var mount=el('slbGdgMount');
    if(!mount)return;
    if(mount.dataset.gdgReady==='1')return;
    mount.dataset.gdgReady='1';
    mount.innerHTML=pageHtml();
  }

  function isOpen(){
    var panel=el('slbGdgPanel');
    return !!(panel&&!panel.classList.contains('hidden'));
  }

  function register(){
    w.SLB=w.SLB||{};
    if(w.SLB.features&&typeof w.SLB.features.register==='function'){
      w.SLB.features.register(TAB,{onOpen:init,reload:init});
    }
  }

  function boot(){
    register();
    if(isOpen())init();
    var panel=el('slbGdgPanel');
    if(panel&&w.MutationObserver&&!panel.dataset.gdgObserved){
      panel.dataset.gdgObserved='1';
      new MutationObserver(function(){if(isOpen())init()}).observe(panel,{attributes:true,attributeFilter:['class']});
    }
  }

  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot);
  else boot();
})(window,document);
